module.exports = "<svg tabindex='-1' viewBox=\"0 0 24 24\"><path d=\"M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./app/assets/icon-left-arrow.svg
// module id = 290
// module chunks = 0